import { ReactElement } from 'react';
import { RadioGroup } from '@op/opds.opux';
import { useMessageGetter } from '@messageformat/react';
import FeedbackMessage from './FeedbackMessage';
import useA11yRadioOptionComponents from '../hooks/useA11yRadioOptionComponents';
import QuestionTile from './QuestionTile';

interface Props {
  number: string;
  correctAnswer: string;
  value: string;
  setValue: (val: string) => void;
  courseNumber: number;
  taskNumber: number;
}

const COURSES_WITH_INFO = [8];

const RadioQuestionTile = ({
  number,
  correctAnswer,
  value,
  setValue,
  courseNumber,
  taskNumber,
}: Props): ReactElement => {
  const hasInfoText = COURSES_WITH_INFO.includes(courseNumber);
  const getMessage = useMessageGetter(
    `course${courseNumber}.task${taskNumber}.question${number}`,
  );

  const radioOptionComponents = useA11yRadioOptionComponents({
    options: [
      {
        value: '1',
        text: getMessage('option1'),
      },
      {
        value: '2',
        text: getMessage('option2'),
      },
      {
        value: '3',
        text: getMessage('option3'),
      },
    ],
    onChange: setValue,
  });
  const hasAnswered = value !== '';
  const infoText = hasAnswered && hasInfoText ? getMessage(`info${value}`) : undefined;
  const labelledbyId = `course${courseNumber}-task${taskNumber}-question${number}-label`;
  return (
    <QuestionTile number={number} question={getMessage(`question`)}>
      <p style={{ display: 'none' }} id={labelledbyId}>
        {`${number}. ${getMessage(`question`)}`}
      </p>
      <RadioGroup value={value} aria-labelledby={labelledbyId}>
        {radioOptionComponents}
      </RadioGroup>
      <FeedbackMessage
        hasAnswered={hasAnswered}
        isCorrect={value === correctAnswer}
        infoText={infoText}
      />
    </QuestionTile>
  );
};

export default RadioQuestionTile;
